import { render, staticRenderFns } from "./messagepartsource.vue?vue&type=template&id=12e7dab5&"
import script from "./messagepartsource.vue?vue&type=script&lang=ts&"
export * from "./messagepartsource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e7dab5')) {
      api.createRecord('12e7dab5', component.options)
    } else {
      api.reload('12e7dab5', component.options)
    }
    module.hot.accept("./messagepartsource.vue?vue&type=template&id=12e7dab5&", function () {
      api.rerender('12e7dab5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messagepartsource.vue"
export default component.exports